/*
 * @Author: atdow
 * @Date: 2024-01-09 14:34:17
 * @LastEditors: null
 * @LastEditTime: 2025-10-30 15:44:55
 * @Description: file description
 */
import createAxios from '/@/utils/axios'

// 下载文件
export function downloadFile (sourcePath: string): ApiPromise {
  return createAxios(
    {
      url: '/unity/file/download',
      params: {
        sourcePath
      },
      responseType: 'blob',
      method: 'GET'
    },
    {
      reductDataFormat: false
    }
  ) as ApiPromise
}

/**
 * 访问日志埋点
 * @param data
 */
export const trackedLogSave = (data: anyObj) => {
  return createAxios({
    url: '/sys/font/log/save',
    data,
    method: 'POST'
  },
  {
    showErrorMessage: false,
    showCodeMessage: false,
    showSuccessMessage: false
  }) as ApiPromise
}

/**
 * 取消请求(用于取消后端请求)
 * @param params
 */
export const cancelRequest = (params: anyObj) => {
  return createAxios({
    url: '/request/cancel',
    params,
    method: 'get'
  },
  {
    cancelDuplicateRequest: false,
    showErrorMessage: false,
    showCodeMessage: false,
    showSuccessMessage: false
  }) as ApiPromise
}

/**
 * 获取所有品牌
 * @param data
 * @returns
 * @link http://192.168.16.90:30333/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E9%A6%96%E9%A1%B5%E7%AE%A1%E7%90%86/pageCommonUsingGET
 */
export function getAllBrand (data: anyObj): ApiPromise {
  return createAxios(
    {
      url: '/home/brand/common/field',
      method: 'POST',
      data
    },
    { cancelDuplicateRequest: false }
  ) as ApiPromise
}

/**
 * 获取通用categoryTree
 * @param params
 * @returns
 * @link http://192.168.16.90:30333/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E9%A6%96%E9%A1%B5%E7%AE%A1%E7%90%86/getCategoryTreeUsingGET
 */
export function getCommonCategoryTree (): ApiPromise {
  return createAxios(
    {
      url: '/home/category/tree',
      method: 'GET',
    },
  ) as ApiPromise
}

/**
 * 获取通用zxList
 * @param params
 * @returns
 * @link http://192.168.16.90:30333/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E9%A6%96%E9%A1%B5%E7%AE%A1%E7%90%86/listCommonZxUsingGET
 */
export function getCommonZxList (): ApiPromise {
  return createAxios(
    {
      url: '/home/category/common/field/zx',
      method: 'GET',
    },
  ) as ApiPromise
}


/**
 * 保存自定义品牌日服用量
 * @returns
 * @link http://192.168.16.90:30310/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/modifyUserSkuUsingPOST
 */
export function saveCustomizedBrandDailyDosage (data: anyObj): ApiPromise {
  return createAxios(
    {
      url: '/user/permissions/userSku/modify',
      method: 'POST',
      data
    },
  ) as ApiPromise
}

/**
 * 获取品牌日服用量
 * @param data
 * @returns
 * @link http://192.168.16.90:30310/receipt-lite/doc.html#/default/%E5%89%8D%E5%8F%B0%E7%94%A8%E6%88%B7%E6%9D%83%E9%99%90%E7%AE%A1%E7%90%86/getPageSkuPermissionsByBrandSpecListUsingPOST
 */
export function getBrandDailyDosage (data: anyObj): ApiPromise {
  return createAxios(
    {
      url: '/user/permissions/brandSpec/sku/searchByList',
      method: 'POST',
      data
    },
  ) as ApiPromise
}
